import { ReactNode } from 'react'

type TagColor =
  | 'blue'
  | 'gray'
  | 'red'
  | 'green'
  | 'yellow'
  | 'indigo'
  | 'purple'
  | 'pink'
  | 'transparent'

export default function Tag({
  color,
  text,
  size = 'sm',
  icon,
  className,
}: {
  color: TagColor
  text: ReactNode
  icon?: ReactNode
  size?: 'sm' | 'lg'
  className?: string
}) {
  let tagClasses = ''

  switch (color) {
    case 'blue':
      tagClasses =
        'bg-blue-100 text-blue-800 dark:bg-gray-800 dark:text-blue-400'
      break
    case 'gray':
      tagClasses =
        'bg-gray-100 text-gray-800 dark:bg-gray-800 dark:text-gray-400'
      break
    case 'red':
      tagClasses = 'bg-red-100 text-red-700 dark:bg-gray-800 dark:text-red-400'
      break
    case 'green':
      tagClasses =
        'bg-green-100 text-green-900 dark:bg-gray-800 dark:text-green-400'
      break
    case 'yellow':
      tagClasses =
        'bg-yellow-100 text-yellow-800 dark:bg-gray-800 dark:text-yellow-300'
      break
    case 'indigo':
      tagClasses =
        'bg-indigo-100 text-indigo-800 dark:bg-gray-800 dark:text-indigo-400'
      break
    case 'purple':
      tagClasses =
        'bg-purple-100 text-purple-800 dark:bg-gray-800 dark:text-purple-400'
      break
    case 'pink':
      tagClasses =
        'bg-pink-100 text-pink-800 dark:bg-gray-800 dark:text-pink-400'
      break
    case `transparent`:
      tagClasses = `bg-app-background  border text-foreground`
      break
    default:
      tagClasses =
        'bg-gray-100 text-gray-800 dark:bg-gray-800 dark:text-gray-400'
  }

  return (
    <span
      className={`block text-[13px] ${
        size === 'sm' ? 'px-3 py-0.5' : 'h-10 px-4 py-2'
      } flex w-fit items-center gap-2 rounded-3xl font-medium ${className ?? ''} ${tagClasses}`}
    >
      {icon}
      {text}
    </span>
  )
}
